// extracted by mini-css-extract-plugin
module.exports = {"snippet":"style_snippet__1A2yN","info":"style_info__6067_","unread":"style_unread__2dusI"};